import React from "react"
import { Col, Row } from "reactstrap"
import NumberFormat from "../../../../utils/numberFormat"
const SalesInvVoucherView = ({ tabledata, invoiceDetails }) => {
  const desimalrange = localStorage.getItem("desimalrange")

  const handilCalaculationSale = data => {
    return data?.reduce((sum, item) => {
      const price = parseFloat(item?.unit_price || 0)
      const qty = parseFloat(item?.so_quantity || 0)
      return sum + price * qty
    }, 0)
  }

  const handilRetention = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 4
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 2)
          ?.debit_amount || 0
      : 0
    return otherCharge
  }
  const handilAdvRetention = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 2
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 2)
          ?.debit_amount || 0
      : 0
    return otherCharge
  }

  const handilVatchange = data => {
    if (!Array.isArray(data)) return 0

    const match = data.find(detail => detail?.ledger?.account_group_id == 17)

    return match?.credit_amount || match?.debit_amount || 0
  }


  const handleContaAmounts = journalEntryDetails =>
    journalEntryDetails?.reduce(
      (sum, entry) => sum + (parseFloat(entry?.credit_amount) || 0),
      0
    )

  const getLastAmount = journalEntryDetails => {
    const lastEntry = journalEntryDetails[journalEntryDetails?.length - 1]
    return lastEntry?.credit_amount !== null
      ? parseFloat(lastEntry?.credit_amount)
      : parseFloat(lastEntry?.debit_amount) || 0
  }



  return (
    <>
      <Row className="mt-4">
        <Col lg={12}>
          <h5 className="productDetail edittheamtitle">
            {invoiceDetails?.voucher_id == 1 ||
            invoiceDetails?.voucher_id == 3 ||
            invoiceDetails?.voucher_id == 6 ||
            invoiceDetails?.voucher_id == 8
              ? "Details"
              : invoiceDetails?.voucher_id == 13
              ? "Sales Detail"
              : "Material Details"}
          </h5>
        </Col>
        <Col lg={12}>
          <table className="estimation-table mb-4">
            <thead>
              <tr>
                <th>Si No</th>
                <th>Project</th>
                <th>Reference</th>
                <th>Unit</th>
                <th className="text-end pe-5">Quantity</th>
                <th className="text-end pe-5">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="ps-2">1</td>
                <td>{invoiceDetails?.project?.project_code}</td>
                <td>{invoiceDetails?.manufacturing_journal?.code}</td>
                <td>Lsm</td>
                <td className="text-end pe-5">1</td>
                <td className="text-end pe-5">
                  {NumberFormat(
                    invoiceDetails?.sale_total,
                    desimalrange,
                    desimalrange
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
        {invoiceDetails?.voucher_id == 13 &&
        Number(invoiceDetails?.sub_total) == 0 &&
        invoiceDetails?.voucher_invoice != "Sales Account" ? (
          <></>
        ) : (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">Sub Total</div>
                </Col>
                <Col lg="3" className="py-2">
                  {[13, 18].includes(invoiceDetails?.voucher_id) &&
                  invoiceDetails?.voucher_invoice == "Sales Invoice" ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        invoiceDetails?.sale_total,
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : [13, 18].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice ==
                      "Sales Product Invoice" ? (
                    <div className="text-end pr-28-values">
                      {invoiceDetails?.voucher_id == 18
                        ? NumberFormat(
                            Number(invoiceDetails?.sub_total),
                            desimalrange,
                            desimalrange
                          )
                        : NumberFormat(
                            Number(
                              handilCalaculationSale(
                                invoiceDetails?.salesvoucher?.materials
                              )
                            ),
                            desimalrange,
                            desimalrange
                          )}
                    </div>
                  ) : [13, 18].includes(invoiceDetails?.voucher_id) &&
                    ["Sales Account", "Sales Voucher"].includes(
                      invoiceDetails?.voucher_invoice
                    ) ? (
                    <div className="text-end pr-28-values">
                      {["Sales Account", "Purchase Account"].includes(
                        invoiceDetails?.voucher_invoice
                      )
                        ? NumberFormat(
                            Number(
                              getLastAmount(
                                invoiceDetails?.journal_entry
                                  ?.journal_entry_details || []
                              )
                            ),
                            desimalrange,
                            desimalrange
                          )
                        : NumberFormat(
                            Number(
                              handleContaAmounts(
                                invoiceDetails?.journal_entry
                                  ?.journal_entry_details || []
                              )
                            ),
                            desimalrange,
                            desimalrange
                          )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
        {invoiceDetails?.voucher_id == 13 &&
        invoiceDetails?.voucher_invoice == "Sales Invoice" &&
        handilRetention(invoiceDetails?.journal_entry?.journal_entry_details) >
          0 ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {invoiceDetails == null ? "" : "Retention"}
                  </div>
                </Col>
                <Col lg="3" className="py-2">
                  {invoiceDetails?.voucher_id == 13 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        handilRetention(
                          invoiceDetails?.journal_entry?.journal_entry_details
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {invoiceDetails?.voucher_id == 13 &&
        invoiceDetails?.voucher_invoice == "Sales Invoice" &&
        handilAdvRetention(
          invoiceDetails?.journal_entry?.journal_entry_details
        ) > 0 ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {invoiceDetails == null ? "" : "Advance Retention"}
                  </div>
                </Col>
                <Col lg="3" className="py-2">
                  {invoiceDetails?.voucher_id == 13 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        handilAdvRetention(
                          invoiceDetails?.journal_entry?.journal_entry_details
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}

        {(invoiceDetails?.voucher_id == 13 &&
          invoiceDetails?.voucher_invoice == "Sales Voucher") ||
        (invoiceDetails?.voucher_id == 13 &&
          handilVatchange(
            invoiceDetails?.journal_entry?.journal_entry_details
          ) == 0) ||
        Number(
          handilVatchange(invoiceDetails?.journal_entry?.journal_entry_details)
        ) == 0 ? (
          <></>
        ) : (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {[
                      "Sales Invoice",
                      "Sales Product Invoice",
                      "Purchase Invoice",
                    ].includes(invoiceDetails?.voucher_invoice)
                      ? "VAT"
                      : ""}
                  </div>
                </Col>

                <Col lg="3" className="py-2">
                  {[13, 18, 4].includes(invoiceDetails?.voucher_id) &&
                  [
                    "Sales Invoice",
                    "Sales Product Invoice",
                    "Purchase Invoice",
                  ].includes(invoiceDetails?.voucher_invoice) ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        handilVatchange(
                          invoiceDetails?.journal_entry?.journal_entry_details
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )}

        {invoiceDetails?.voucher_id == 13 &&
        invoiceDetails?.voucher_invoice == "Sales Product Invoice" &&
        Number(
          handilCalaculationSale(invoiceDetails?.salesvoucher?.materials)
        ) != Number(invoiceDetails?.sub_total) ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">Net Total</div>
                </Col>
                <Col lg="3" className="py-2">
                  <div className="text-end pr-28-values">
                    {Number(invoiceDetails?.sub_total).toFixed(desimalrange)}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}

        {([13, 18].includes(invoiceDetails?.voucher_id) &&
          invoiceDetails?.voucher_invoice == "Sales Invoice") ||
        ([15, 4].includes(invoiceDetails?.voucher_id) &&
          invoiceDetails?.voucher_invoice == "Purchase Invoice") ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {invoiceDetails == null ? "" : "Net Total"}
                  </div>
                </Col>
                <Col lg="3" className="py-2">
                  {[13, 18].includes(invoiceDetails?.voucher_id) ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(invoiceDetails?.sub_total),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </Row>

      <Row>
        {invoiceDetails?.narration ? (
          <Col lg={6} md={8} sm={12} className="pb-4">
            <div className="supplier-td-head">Narration</div>
            <div className="supplier-td-body">
              {invoiceDetails ? invoiceDetails?.narration : "-"}
            </div>
          </Col>
        ) : null}
      </Row>
      <Row>
        {invoiceDetails?.purchaseorder?.delivery_terms ? (
          <Col lg={6} md={8} sm={12}>
            <div className="supplier-td-head">Delivery Terms</div>
            <div
              className="supplier-td-body"
              dangerouslySetInnerHTML={{
                __html: invoiceDetails?.purchaseorder?.delivery_terms || "-",
              }}
            />
          </Col>
        ) : null}
      </Row>
      <Row>
        {invoiceDetails?.purchaseorder?.general_terms ? (
          <Col lg={6} md={8} sm={12}>
            <div className="supplier-td-head">General Terms</div>
            <div
              className="supplier-td-body"
              dangerouslySetInnerHTML={{
                __html: invoiceDetails?.purchaseorder?.general_terms || "-",
              }}
            />
          </Col>
        ) : null}
      </Row>
    </>
  )
}

export default SalesInvVoucherView
